import React, { useState, useEffect } from "react";
import AreYouSureModal from "../../../../components/modals/areYouSureModal";
import authServices from "../../../../services/authServices";
import CustomIcon from "../../../../components/customIcon";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import moment from "moment";
import {
  Button,
  Card,
  CardContent,
  Divider,
  Stack,
  Typography,
  Box,
} from "@mui/material";
import userServices from "../../../../services/userServices";
import { useSnackbar } from "notistack";
import hufService from "../../../../services/hufService";
import HufCreateDLTModel from "./HufCreateDLTModel";
import { Tabs, Tab } from "@mui/material";
import { getAccountLink, getTransactionLink } from '../../../../utils/blockchainExplorer';

const HufDltWallet = ({ entityId, getHufDetails }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [primaryOpen, setPrimaryOpen] = useState(false);
  const [availableBlockchainAccounts, setAvailableBlockchainAccounts] =
    useState([]);
  const [blockchainAccountModal, setBlockchainAccountModal] = useState(false);
  const [hufAccount, setHufAccount] = useState();
  const [dltWalletId, setDltWalletId] = useState();
  const [selectedNetwork, setSelectedNetwork] = useState("polygon"); // default network
  const [availablePolygonBlockchainAccounts, setAvailablePolygonBlockchainAccounts] = useState([]);
  const [availableMstBlockchainAccounts, setAvailableMstBlockchainAccounts] = useState([]);
  const { enqueueSnackbar } = useSnackbar();

  const getHufAccount = async () => {
    const res = await userServices.getHufById(entityId);
    if (res && res.success) {
      setHufAccount(res.data[0]);
    } else {
      enqueueSnackbar("Somthing went wrong", {
        variant: "error",
        autoHideDuration: 4000,
      });
    }
  };
  useEffect(() => {
    getHufAccount();
  }, [blockchainAccountModal]);

  const handlePrimary = async () => {
    // const res = await userServices.updatePrimaryDLTAccount({
    //   entityId: entityId,
    //   dltWalletId: dltWalletId,
    //   entityType:"HUF"
    // });

    let res;
    if(selectedNetwork == 'algorand')
      res = await userServices.updatePrimaryDLTAccount({ entityId: entityId, dltWalletId: dltWalletId, entityType: "HUF" });
    else if (selectedNetwork === 'polygon')
      res = await userServices.updatePrimaryDLTPolygonAccount({ entityId: entityId, dltWalletId: dltWalletId, entityType: "HUF" });

    if (res && res.success) {
      getHufAccount();
    }
  };

  const handleRemove = async () => {
    // const res = await userServices.removeDLTAccount({
    //   entityId: entityId,
    //   dltWalletId: dltWalletId,
    //   entityType:"HUF"
    // });
     let res;
    if(selectedNetwork == 'algorand')
      res = await userServices.removeDLTAccount({ entityId: entityId, dltWalletId: dltWalletId, entityType: "HUF" });
    else if (selectedNetwork === 'polygon')
      res = await userServices.removeDLTPolygonAccount({ entityId: entityId, dltWalletId: dltWalletId, entityType: "HUF" });

    if (res && res.success) {
      getHufAccount();
      enqueueSnackbar("DLT Account Deleted Successfully!", {
        variant: "success",
        anchorOrigin: { horizontal: "right", vertical: "top" },
        autoHideDuration: 3000,
      });
    } else
      enqueueSnackbar(
        "This DLT Account is Holding Some Digital Assets in it. Please Contact RealX Admin for More Information!",
        {
          variant: "error",
          anchorOrigin: { horizontal: "center", vertical: "bottom" },
          autoHideDuration: 9000,
        }
      );
  };
  const fetchDltWallet = async () => {
    let dltWallet = await userServices.getDltWallet(entityId);

    // Polygon wallet (new)
    let network = "polygon";
    let polygonDltWallet = await userServices.getDltWallet(entityId, network);
    setAvailablePolygonBlockchainAccounts(polygonDltWallet.data);
    let mstDltWallet = await userServices.getDltWallet(entityId, "mst");
    setAvailableMstBlockchainAccounts(mstDltWallet.data);
    setAvailableBlockchainAccounts(dltWallet.data);
  };

  useEffect(() => {
    fetchDltWallet();
  }, [hufAccount]);

  useEffect(() => {
    // Set initial selected network based on available accounts
    // Priority: Polygon if available, otherwise Algorand
    if (availablePolygonBlockchainAccounts.length > 0) {
      setSelectedNetwork("polygon");
    } else if (availableBlockchainAccounts.length > 0) {
      setSelectedNetwork("algorand");
    } else if (availableMstBlockchainAccounts.length > 0) {
      setSelectedNetwork("mst");
    }
  }, [availablePolygonBlockchainAccounts, availableBlockchainAccounts, availableMstBlockchainAccounts]);

  const handleDLTCreationStatus = async (huf, status) => {
    const res = await hufService.updateDLTCreationStatusHUF({
      hufId: huf,
      status,
    });
    if (res && res.success) {
      getHufAccount();
    }
  };

  const copyUrl = (account) => {
    navigator.clipboard.writeText(account);
    enqueueSnackbar("Copied to Clickboard", {
      variant: "success",
      anchorOrigin: { horizontal: "right", vertical: "top" },
      autoHideDuration: 800,
    });
  };

  const currentAccounts =
  selectedNetwork === "polygon"
    ? availablePolygonBlockchainAccounts
    : selectedNetwork === "mst"
    ? availableMstBlockchainAccounts
    : availableBlockchainAccounts;

  return (
    <Stack spacing={3} width={{md:"50%",sm:"100%",xs:"100%"}} padding={{xs: "10px", sm: "10px"}}>
      <AreYouSureModal
        open={primaryOpen}
        setOpen={setPrimaryOpen}
        handleYes={handlePrimary}
        message={"Are You Sure About Updating your Primary DLT Account?"}
        publicAddress={availableBlockchainAccounts[currentIndex]?.publicAddress}
        publicAddressMessage={"Your New Primary DLT Account Address"}
      />
      <AreYouSureModal
        open={deleteOpen}
        setOpen={setDeleteOpen}
        handleYes={handleRemove}
        message={"Are You Sure About Permanently Deleting this DLT Account?"}
        note={"This action can not be undo!"}
        publicAddress={availableBlockchainAccounts[currentIndex]?.publicAddress}
        publicAddressMessage={"DLT Account Address To Be Removed"}
      />

      <Typography fontSize={"14px"}>Available Blockchain Accounts</Typography>

      {(
        availablePolygonBlockchainAccounts.length > 0 ||
        availableBlockchainAccounts.length > 0 ||
        availableMstBlockchainAccounts.length > 0
      ) && (
        <>
          <Tabs
            value={selectedNetwork}
            onChange={(e, newValue) => setSelectedNetwork(newValue)}
            centered
          >
            {/* Priority to polygon: show as first tab if exists! */}
            {availablePolygonBlockchainAccounts.length > 0 && (
              <Tab label="Polygon" value="polygon" />
            )}
            {availableBlockchainAccounts.length > 0 && (
              <Tab label="Algorand" value="algorand" />
            )}
            {availableMstBlockchainAccounts.length > 0 && (
              <Tab label="MST" value="mst" />
            )}
          </Tabs>

          <Stack
            flexDirection={"column"}
            sx={{
              overflowX: { xs: "auto", sm: "auto", md: "hidden" },
              flexWrap: "wrap",
            }}
            gap={2}
          >
            {currentAccounts.length > 0 ? (
              currentAccounts
                .sort((a, b) => (b.isPrimary ? 1 : -1) - (a.isPrimary ? 1 : -1)) // Sort primary account first
                .map((account, index) => {
                  return (
                    <Stack
                      flexDirection={"row"}
                      gap={1}
                      sx={{
                        width: "100%"
                      }}
                      key={account._id || index}
                    >
                      <Stack
                        flexDirection={"row"}
                        sx={{
                          borderRadius: "10px",
                          boxShadow: "0px 1px 6px 0px #51515129",
                          width: "100%",
                        }}
                      >
                        <Box sx={{ padding: "2px" }} width={"100%"}>
                          <Box
                            sx={{ display: "flex" }}
                            justifyContent={"space-between"}
                            alignItems={"center"}
                          >
                            <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center", gap: 1 }}>
                            <Typography sx={{ fontSize: {xs: 8, sm: 12, md: 14, lg: 16} }}>
                              #{index + 1}. ...{account.publicAddress?.slice(-25)}
                            </Typography>
                            <Box
                              onClick={(e) => {
                                e.stopPropagation();
                                e.preventDefault();
                                copyUrl(account.publicAddress);
                              }}
                              sx={{
                                bgcolor: "#f4f6f7",
                                padding: "7px",
                                borderRadius: "50%",
                                hight: "20px",
                                width: "30px",
                              }}
                            >
                              <CustomIcon
                                name="copy"
                                sx={{
                                  bgcolor: "#FFF",
                                  backgroundColor: "#333333",
                                  cursor: "pointer",
                                }}
                              />
                            </Box>
                            </Box>
                            <Box sx={{ marginLeft: "4px" }}>
                              {account.isPrimary ? (
                                <Typography
                                  sx={{
                                    color: "white",
                                    background: "#21ab37",
                                    padding: "2px 15px !important",
                                    fontSize: {xs: 8, sm: 10, md: 12, lg: 14},
                                    border: "1px solid #21ab37",
                                    borderRadius: "10px",
                                  }}
                                >
                                  Primary Account
                                </Typography>
                              ) : (
                                <Stack
                                  flexDirection={"row"}
                                  alignItems={"center"}
                                  gap={1}
                                  sx={{ m: "0 !important" }}
                                >
                                  <Button
                                    variant="contained"
                                    sx={{
                                      p: "4px 15px !important",
                                      fontSize: {xs: 8, sm: 10, md: 12, lg: 14},
                                      marginLeft: "5px",
                                    }}
                                    onClick={() => {
                                      setCurrentIndex(index);
                                      setPrimaryOpen(true);
                                      setDltWalletId(account._id);
                                    }}
                                  >
                                    Make Primary
                                  </Button>
                                  <RemoveCircleOutlineIcon
                                    sx={{ color: "red", cursor: "pointer" }}
                                    onClick={() => {
                                      setCurrentIndex(index);
                                      setDeleteOpen(true);
                                      setDltWalletId(account._id);
                                    }}
                                  />
                                </Stack>
                              )}
                            </Box>
                          </Box>
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "row",
                              justifyContent: "space-between",
                              alignItems: "center",
                              paddingTop: "10px",
                            }}
                          >
                            <Box>
                              <Typography
                                sx={{
                                  fontWeight: "600",
                                  fontSize: {xs: 8, sm: 10, md: 12, lg: 14},
                                  paddingBottom: "10px",
                                }}
                              >
                                {account?.name?.slice(0, 30)}
                              </Typography>
                            </Box>
                            <Box>
                              <Typography sx={{ fontSize: {xs: 8, sm: 10, md: 12, lg: 14} }}>
                                {account?.created_at
                                  ? ` Created On: ${moment(
                                      account?.created_at
                                    ).format("DD-MM-YYYY")}`
                                  : ""}
                              </Typography>
                            </Box>
                          </Box>
                          <Button
                            variant="outlined"
                            size="small"
                            sx={{ fontSize: "12px !important" }}
                            onClick={() => {
                              const explorerUrl = getAccountLink(
                                selectedNetwork,
                                account.publicAddress
                              );
                              window.open(explorerUrl, "_blank");
                            }}
                          >
                            {selectedNetwork === "algorand"
                              ? "View on Pera Explorer" : selectedNetwork === "mst"
                              ? "View on MSTscan"
                              : "View on Polygonscan"}
                          </Button>
                        </Box>
                      </Stack>
                    </Stack>
                  );
                })
            ) : (
              <Typography variant="subtitle1">
                You have not made any DLT accounts yet
              </Typography>
            )}
          </Stack>
        </>
      )}

      <Stack flexDirection={"row"} gap={1} justifyContent={"center"}>
        <Button
          onClick={() =>
            hufAccount?.walletInfo?.isAllowedToCreateDLT == "APPROVED"
              ? setBlockchainAccountModal(true)
              : handleDLTCreationStatus(hufAccount?._id, "PENDING")
          }
          variant="contained"
          sx={{ width: "max-content", py: "10px !important" }}
          disabled={
            (availableBlockchainAccounts?.length +
              availablePolygonBlockchainAccounts?.length +
              availableMstBlockchainAccounts?.length >= 5 ) ||
            hufAccount?.walletInfo?.isAllowedToCreateDLT == "PENDING" ||
            ["PENDING", "REJECTED"].includes(hufAccount?.status)
          }
        >
          {hufAccount?.walletInfo?.isAllowedToCreateDLT == "APPROVED"
            ? "Create a New DLT Account"
            : hufAccount?.walletInfo?.isAllowedToCreateDLT == "PENDING"
            ? "Request Submitted to RealX Admin"
            : "Request to Create a New DLT Account"}
        </Button>

        {hufAccount?.walletInfo?.isAllowedToCreateDLT == "PENDING" && (
          <Button
            variant="contained"
            sx={{ py: "7px !important" }}
            onClick={() => handleDLTCreationStatus(hufAccount?._id, "CREATED")}
          >
            Cancel Request
          </Button>
        )}
      </Stack>
      {blockchainAccountModal && (
        <HufCreateDLTModel
          open={blockchainAccountModal}
          setOpen={setBlockchainAccountModal}
          huf={hufAccount}
          getHufDetails={() => getHufDetails()}
          disableAlgorandOption = {true}
          disablePolygonOption = {availablePolygonBlockchainAccounts.length >= 5}
        />
      )}
    </Stack>
  );
};

export default HufDltWallet;
